/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popYoutube.vue?vue&type=template&id=1aa769b1&scoped=true"
import script from "./popYoutube.vue?vue&type=script&lang=js"
export * from "./popYoutube.vue?vue&type=script&lang=js"
import style0 from "./popYoutube.vue?vue&type=style&index=0&id=1aa769b1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa769b1",
  null
  
)

export default component.exports